export interface BrowserInfo {
  browserName: string;
  browserVersion: string;
}

export interface DeviceInfo {
  deviceType: 'Desktop' | 'Mobile' | 'Tablet';
  os: string;
}

export interface ViewportInfo {
  viewport: string;
  windowWidth: number;
  windowHeight: number;
}

export interface UserEnvironment extends BrowserInfo, DeviceInfo {
  screenWidth: number;
  screenHeight: number;
  timezone: string;
  language: string;
  userAgent: string;
  referrer: string;
}

export const getBrowserInfo = (): BrowserInfo => {
  const ua = navigator.userAgent;
  let browserName = 'Unknown';
  let browserVersion = 'Unknown';

  // Detect browser
  if (ua.includes('Chrome') && !ua.includes('Edg')) {
    browserName = 'Chrome';
    const match = ua.match(/Chrome\/([0-9.]+)/);
    browserVersion = match ? match[1] : 'Unknown';
  } else if (ua.includes('Firefox')) {
    browserName = 'Firefox';
    const match = ua.match(/Firefox\/([0-9.]+)/);
    browserVersion = match ? match[1] : 'Unknown';
  } else if (ua.includes('Safari') && !ua.includes('Chrome')) {
    browserName = 'Safari';
    const match = ua.match(/Version\/([0-9.]+)/);
    browserVersion = match ? match[1] : 'Unknown';
  } else if (ua.includes('Edg')) {
    browserName = 'Edge';
    const match = ua.match(/Edg\/([0-9.]+)/);
    browserVersion = match ? match[1] : 'Unknown';
  }

  return { browserName, browserVersion };
};

export const getDeviceInfo = (): DeviceInfo => {
  const ua = navigator.userAgent;
  let deviceType: 'Desktop' | 'Mobile' | 'Tablet' = 'Desktop';
  let os = 'Unknown';

  // Detect device type
  if (/Mobi|Android/i.test(ua)) {
    deviceType = 'Mobile';
  } else if (/Tablet|iPad/i.test(ua)) {
    deviceType = 'Tablet';
  }

  // Detect OS
  if (ua.includes('Windows')) {
    os = 'Windows';
  } else if (ua.includes('Mac OS')) {
    os = 'macOS';
  } else if (ua.includes('Linux')) {
    os = 'Linux';
  } else if (ua.includes('Android')) {
    os = 'Android';
  } else if (ua.includes('iOS') || ua.includes('iPhone') || ua.includes('iPad')) {
    os = 'iOS';
  }

  return { deviceType, os };
};

export const getViewportInfo = (): ViewportInfo => {
  return {
    viewport: `${window.innerWidth}x${window.innerHeight}`,
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight,
  };
};

export const getUserEnvironment = (): UserEnvironment => {
  const { browserName, browserVersion } = getBrowserInfo();
  const { deviceType, os } = getDeviceInfo();

  return {
    browserName,
    browserVersion,
    deviceType,
    os,
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    language: navigator.language,
    userAgent: navigator.userAgent,
    referrer: document.referrer || 'Direct',
  };
};
